module.exports = __webpack_public_path__ + "img/7cef73f20c73b34b963fbc4797964f03.svg";